import React from "react";
import PlusIcon from "../../../assets/plus";
import MinusIcon from "../../../assets/minusIcon";
import SublimationSubMenu from "./SublimationSubMenu";

interface Props {
  jwtToken: string;
  expandedGroup: string;
  setExpandedGroup: React.Dispatch<React.SetStateAction<string>>;
  name: string;
}

const SublimationMenu = ({ jwtToken, expandedGroup, setExpandedGroup, name }: Props) => (
  <div className="sidebar-menu">
    <div
      className="menu-label"
      role="menubar"
      onClick={() => {
        setExpandedGroup(expandedGroup === name ? "" : name);
      }}
    >
      {"Biz Co.Lab"}
      <div className="expand-icon">
        {expandedGroup === name ? (
          <MinusIcon fill="white" width={10} />
        ) : (
          <PlusIcon fill="white" width={10} />
        )}
      </div>
    </div>
    {expandedGroup === name && (
      <div className="sub-menu">
        <SublimationSubMenu jwt={jwtToken} />
      </div>
    )}
  </div>
);

export default SublimationMenu;
